import styled from 'styled-components';
import Carousel from 'react-bootstrap/Carousel';

export const ContCarousel = styled(Carousel)`
  padding: 0rem 0 3rem 0;

  .carousel-indicators {
    z-index: 7;
  }

  @media (max-width: 1023px) {
    display: none;
  }

  .carousel-indicators {
    margin-top: -50px;
    z-index: 10;
    bottom: -8px;
  }

  .carousel-indicators .active {
    background-color: #fff;
  }

  .carousel-indicators li {
    background-color: #fff;
    width: 40px;
    height: 12px;
    margin: 0 4px;
  }
`;

export const CarouselItem = styled(Carousel.Item)`
  padding: ${(props) => (props.isloading ? '2rem 8rem' : '8rem 5rem')};
  padding-left: 5rem;
  padding-bottom: 13rem !important;
  min-height: 920px;
  max-height: 1000px;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center 65%;
  background-color: ${(props) => props.background};
  position: relative;


  h1 {
    font-size: ${(props) => 45 * props.fontsizemultiplier};
    color: ${(props) => props.color};
  }

  h3 {
    font-size: ${(props) => 20 * props.fontsizemultiplier};
  }

  .overlay {
    display: flex !important;
  }

  .cont-botones-programarcita-voz-afiliado{
    padding-top: 45rem;
    margin-left: -1.5rem;
  }

  
  @media (max-width: 1600px) {
    min-height: 750px;
    .cont-botones-programarcita-voz-afiliado{
      padding-top: 35rem;
    }
  }

  @media (max-width: 1400px) {
    min-height: 700px;
    .cont-botones-programarcita-voz-afiliado{
      padding-top: 35rem;
    }
  }

  @media (max-width: 1250px) {
    padding-left: 4rem;
    min-height: 650px;
    .cont-botones-programarcita-voz-afiliado{
      padding-top: 32rem;
    }
  }

  @media (max-width: 1200px) {
    min-height: 600px;
    .cont-botones-programarcita-voz-afiliado{
      padding-top: 26rem;
    }
  }

  .options-container {
    position: absolute;
    z-index: 99;
    top: 7rem;
    left: 1.7rem;
    width: 36rem;
    border-bottom-left-radius: 3rem;
    border-bottom-right-radius: 3rem;
    background-color: ${(props) => props.backgroundoption};
    overflow: hidden;

    .option {
      font-size: 1.8rem;
      text-align: center;
      font-weight: 700;
      padding: 0.5rem 1rem;
      border-bottom: 1px solid #fff;
      cursor: pointer;
      color: ${(props) => props.colorprincipal};
    }

    .contact-btn {
      display: flex !important;
      align-items: center !important;
      justify-align: center !important;
      gap: 10px;
      overflow: hidden;
      padding: 0.3rem 2rem;
      cursor: pointer;
      // background-color: red;
      color: ${(props) => props.colorprincipal};
      width: 100%;
      font-weight: 700;
      transition: all 0.3s;

      p{
        text-align: center !important;
        width: 100%;
      }

      &:hover {
        filter: brightness(1.1);
        letter-spacing: 1px;
      }

    @media (max-width: 1199px) {
      top: 5rem;
      width: 30rem;
    }
  }

  .z-index-1 {
    z-index: 2;
  }

  @media (max-width: 1023px) {
    min-height: 30vh;
    padding-left: 0;
    background-position: left;

    h3 {
      font-size: ${(props) => 14 * props.fontsizemultiplier};
    }

    h1 {
      font-size: ${(props) => 35 * props.fontsizemultiplier};
    }
  }
`;

export const Span = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 30px;
  background-color: #fff;
`;

export const SelectButton = styled.div`
  /* outline: 1px solid red; */
  background-color: ${(props) =>
    props.buttonSelected === false
      ? props.theme.azulPpal
      : props.theme.azulVerde};
  color: #fff;
  min-width: 35rem;
  height: 7rem;
  border: 1px solid;
  padding: 1rem 1rem;
  margin-right: 1rem;
  border-radius: ${(props) =>
    props.buttonSelected === false ? '40px;' : '40px 40px 0 0;'};
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;

  .cont-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
  }

  h2 {
    margin: 0 0 0 1rem;
    font-size: 2rem;
    color: #fff;
    justify-self: flex-start;
  }

  @media (max-width: 1199px) {
    min-width: 30rem;
    height: 5rem;
    padding: 0rem 1rem;
  }
`;

export const BtnPeticiones = styled.button`
  border-style: none;
  box-shadow: 0px 0px 6px #00000029;
  padding: 1rem 2rem;
  border-radius: 100px;
  font-weight: bold;
  font-size: 2rem;
  color: ${(props) => props.color};
  background-color: ${(props) => props.background};
`;

// Estilos del menu flotante del carousel ubicado abajo a la izquierda
export const ContMenuFlotanteCarousel = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  padding: 10px 0;
  position: absolute;
  margin-left: 8rem;
  width: 80%;
  padding: 0;
  bottom: 0px;
  z-index: 0;

  @media (max-width: 1024px) {
    display: none;
  }

  .cont-item-menu-flotante {
    position: relative;
    display: flex !important;
    align-items: center;
    max-width: 130px;
    min-width: 130px;
    flex-wrap: wrap;
    height: 150px !important;
    font-size: 10px;
    z-index: 1;
    padding: 0rem 0.7rem 2rem 0.7rem;
    background-color: ${(props) => props.background};
    border-radius: 50% 50% 0 0;
    transition: 0.3s all;
    box-shadow: 0px 0px 6px #00000029;
  }
`;

export const ContMenuLinks = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  padding: 10px 0;
  position: absolute;
  margin-left: 8rem;
  width: 80%;
  padding: 0;
  bottom: 0px;
  z-index: 1;

  @media (max-width: 769px) {
    display: none;
  }

  .cont-item-menu-flotante {
    position: relative;
    display: flex !important;
    align-items: center;
    max-width: 130px;
    min-width: 130px;
    flex-wrap: wrap;
    height: 150px !important;
    font-size: 10px;
    z-index: 1;
    padding: 0rem 0.7rem 2rem 0.7rem;
    background-color: transparent;
    border-radius: 50% 50% 0 0;
    transition: 0.1s all;

    .aLink {
      text-align: center;
      padding: 2rem 0.7rem 4rem 0.7rem;
      position: absolute;
      cursor: pointer;
      transition: 0.2s all;

      &:hover {
        filter: brightness(1.1);
        padding: 0.5rem 0.7rem 4rem 0.7rem;
        color: #156dbc;
      }

      a {
        font-weight: bold !important;
        font-size: ${(props) => 13 * props.fontSizeMultiplier} !important;
        color: ${(props) => props.color};
        transition: 0.3s all;
      }
    }
  }
`;

export const Svg = styled.svg`
  position: absolute;
  bottom: 0;
  left: 0;
  // top: 20px;
  // padding-top: 100rem;
  margin-bottom: -6%;
  width: 100%;
  z-index: 0;
  margin-top: 0rem;
`;


export const ContMenuLinksTwo = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  padding: 10px 0;
  position: relative;
  margin-top: 0.5rem;
  width: 100%;
  padding: 0;
  bottom: 0px;
  z-index: 1;

  @media (max-width: 769px) {
    display: none;
  }

  .cont-item-menu-flotante {
    .cont-img {
      position: relative;
      display: flex !important;
      justify-content: center;
      align-items: center;
      max-width: 90px;
      min-width: 90px;
      flex-wrap: wrap;
      height: 90px !important;
      font-size: 12px;
      z-index: 1;
      // padding: 0rem 0.7rem 2rem 0.7rem;
      background-color: #808080;
      border-radius: 50%;
      transition: 0.2s all;

      img{
        width: 70%;
        position: relative !important;
        max-height: 5rem !important;
        min-height: 5rem !important;
      }

      &:hover {
        transform: scale(1.1);
        filter: brightness(1.1);
      }

    }

    .aLink {
      display: flex !important;
      justify-content: center;
      align-items: center;
      text-align: center;
      max-width: 90px;
      min-width: 90px;

      padding: 2rem 0.7rem 4rem 0.7rem;
      position: absolute;
      cursor: pointer;
      transition: 0.2s all;
      padding: 0.7rem 0.2rem;

      &:hover {
        filter: brightness(1.1);
        padding: 0.5rem 0.7rem 4rem 0.7rem;
        color: #156dbc;
      }

      a {
        font-weight: bold !important;
        // font-size: ${(props) => 4 * props.fontSizeMultiplier} !important;
        font-size: 10px !important;
        color: ${(props) => props.color};
        transition: 0.3s all;
      }
    }
  }

`;